import { isMobile, getQueryParams } from "@kubera/common";
import { queryParams } from "routes";

const HANDOFF_TOKEN_KEY = "LINK_ACCOUNT_HANDOFF_TOKEN_KEY";

export const handoffExpiredMs = 10 * 60 * 1000;

export const handoffResult = {
  SUCCESS: "success",
  FAILURE: "failure",
  EXIT: "exit"
};

const writeHandoffEntry = entry => {
  const value = JSON.stringify(entry);
  sessionStorage.setItem(HANDOFF_TOKEN_KEY, value);
  localStorage.setItem(HANDOFF_TOKEN_KEY, value);
};

const readHandoffEntry = () => {
  const value = sessionStorage.getItem(HANDOFF_TOKEN_KEY) || localStorage.getItem(HANDOFF_TOKEN_KEY);
  if (!value === true) {
    return null;
  }

  try {
    const entry = JSON.parse(value);
    if (!entry === true || !entry.ts === true) {
      return null;
    }
    if (new Date().getTime() - entry.ts > handoffExpiredMs) {
      return null;
    }
    return entry;
  } catch (e) {
    return null;
  }
};

export const setHandoffToken = token => {
  writeHandoffEntry({ token: token, ts: new Date().getTime() });
};

export const consumeHandoffToken = () => {
  writeHandoffEntry({ ts: new Date().getTime() });
};

export const readHandoffToken = () => {
  const entry = readHandoffEntry();
  if (entry === null || !entry.token === true) {
    return null;
  }
  return entry.token;
};

export const isHandoffTokenConsumed = () => {
  const entry = readHandoffEntry();
  return entry !== null && !entry.token === true;
};

export const parseProviderCallback = params => {
  if (!params[queryParams.CONNECTION_ID] === false) {
    if (!params[queryParams.SE_ERROR_CLASS] === true) {
      return {
        result: handoffResult.SUCCESS,
        data: { connectionId: params[queryParams.CONNECTION_ID] }
      };
    }
    return {
      result: handoffResult.FAILURE,
      data: {
        errorCode: params[queryParams.SE_ERROR_CLASS],
        errorMessage: params[queryParams.SE_ERROR_CLASS]
      }
    };
  }

  if (!params[queryParams.ERROR] === false) {
    return {
      result: handoffResult.EXIT,
      data: {
        errorCode: params[queryParams.ERROR],
        errorMessage: params[queryParams.ERROR_DESCRIPTION] || params[queryParams.ERROR]
      }
    };
  }

  return null;
};

export const isMobileHandoffReturn = () => {
  if (isMobile() === false) {
    return false;
  }
  if (readHandoffEntry() === null) {
    return false;
  }
  return !parseProviderCallback(getQueryParams(window.location)) === false;
};
